<template>
  <div class="read-write">
    <el-dialog
      :visible="visible"
      @close="$emit('update:visible', false)"
      width="500px"
      :close-on-click-modal="false"
    >
      <div
        slot="title"
        class="Diatitle"
      >
        <span>读写寄存器</span>
      </div>
      <el-tabs type="border-card" v-model="form.activeType" @tab-click="onTabClick">
        <el-tab-pane v-for="(item,index) in list" :key="index" :label="item" :name="`${index}`">
          <el-form v-if="[0,1].includes(Number(index))" :model="form" label-width="120px">
            <!-- <el-form-item v-for="(item,index) in registerAddressList" :key="index" :label="item.label">
              <el-select v-if="item.contentType === 'select'" v-model="item.modelValue">
                <el-option
                  v-for="(val,valIndex) in item.options"
                  :key="valIndex"
                  :label="val.label"
                  :value="val.value"
                ></el-option>
              </el-select>
              <el-input v-else v-model="item.modelValue" placeholder="请输入" />
            </el-form-item> -->
            <el-form-item label="寄存器起始地址">
              <el-select class="w__100" v-model="form.registerAddress" filterable placeholder="请选择">
                <el-option
                  v-for="(val,valIndex) in registerAddressList"
                  :key="valIndex"
                  :label="val.label"
                  :value="val.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.activeType === '0'" label="寄存器个数">
              <el-input-number
                class="w__100"
                v-model="form.registerNum"
              />
            </el-form-item>
            <el-form-item v-else label="数据">
              <el-select
                v-if="useContentType(form.registerAddress) === 'select'"
                class="w__100"
                v-model="form.data"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val,valIndex) in useOptions(form.registerAddress)"
                  :key="valIndex"
                  :label="val.label"
                  :value="val.value">
                </el-option>
              </el-select>
              <el-input
                v-else
                v-model="form.data"
                :disabled="useContentDisabled(form.registerAddress)"
                placeholder="请输入数据"
              />
            </el-form-item>
          </el-form>
          <!-- 多个 -->
          <div v-else class="register-list">
            <div
              v-for="(val,valIndex) in registerList"
              :key="valIndex"
              class="register-list-item"
            >
              <el-select v-model="val.registerAddress" filterable placeholder="请选择">
                <el-option
                  v-for="(val,valIndex) in registerAddressList"
                  :key="valIndex"
                  :label="val.label"
                  :value="val.value">
                </el-option>
              </el-select>
              <el-input
                v-if="useContentType(val.registerAddress) === 'input'"
                v-model="val.data"
                :disabled="useContentDisabled(val.registerAddress)"
                placeholder="请输入数据"
              ></el-input>
              <el-select
                v-else-if="useContentType(val.registerAddress) === 'select'"
                class="w__100"
                v-model="val.data"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val,valIndex) in useOptions(val.registerAddress)"
                  :key="valIndex"
                  :label="val.label"
                  :value="val.value">
                </el-option>
              </el-select>
              <el-date-picker
                v-else
                v-model="val.data"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <div class="register-list-item-operate">
                <i v-if="registerList.length-1 !== valIndex || registerList.length > 1" @click="onDel(valIndex)" class="el-icon-delete-solid del"></i>
                <i v-if="valIndex === registerList.length - 1" @click="onPlus" class="el-icon-circle-plus plus"></i>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <template slot="footer">
        <div class="footer">
          <div>
            <el-button
              type="primary"
              plain
              size="small"
              @click="onOpenDetail(1)"
            >保护板数据</el-button>
            <el-button
              type="primary"
              plain
              size="small"
              @click="onOpenDetail(2)"
            >历史故障信息</el-button>
          </div>
          <div>
            <el-button
              type="info"
              plain
              size="small"
              @click="$emit('update:visible', false)"
            >取消</el-button>
            <el-button
              type="primary"
              plain
              size="small"
              @click="commandDown"
            >确定</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <DetailData
      :visible.sync="detailVisible"
      :terminalNo="terminalNo"
      :refresh="refresh"
      :type="detailType"
    />
    <HistoricalFailure
      :visible.sync="historicalVisible"
      :terminalNo="terminalNo"
    />
  </div>

</template>

<script>
import { registerType } from '@/assets/js/registerType.js';
import DetailData from './DetailData.vue';
import HistoricalFailure from './HistoricalFailure.vue';
export default {
  name:'ReadWriteRegister',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    },
    refresh: {
      type: Object,
      default: () => {}
    },
  },
  components:{
    DetailData,
    HistoricalFailure
  },
  data() {
    return {
      form:{
        activeType:'0',
        registerAddress:null,
        registerNum:0,
        data:'',
      },
      detailType:1,
      registerList:[],
      detailVisible:false,
      historicalVisible:false,
      list:['读寄存器', '写单个寄存器', '写多个寄存器'],
      // registerAddressList:[],
    };
  },
  watch:{
    visible:{
      handler(val){
        this.initData();
        // this.registerAddressList = this.getList();
      },
      deep:true,
    },
  },
  computed:{
    // 寄存器起始地址选择
    registerAddressList(){
      const type = this.form.activeType === '0' ? 'R' : 'W';
      let json = registerType.filter(item => item.type.includes(type)) ?? [];
      if(this.form.activeType === '1'){
        json = json.filter(item => item.value !== 'C9' && item.value !== 'D4D5D6');
      }
      return json;
    },
    // 寄存器起始地址选择
    terminalNo(){
      return this.params?.terminalNo ?? ''
    }
  },
  methods: {
    getList(){
      const type = this.form.activeType === '0' ? 'R' : 'W';
      let json = registerType.filter(item => item.type.includes(type)) ?? [];
      if(this.form.activeType === '1'){
        json = json.filter(item => item.value !== 'C9' && item.value !== 'D4D5D6');
      }
      return json;
    },
    // 查看详情
    onOpenDetail(type){
      if(type === 2){
        this.historicalVisible = true;
      }else{
        this.detailType = type;
        this.detailVisible = true;
      }
    },
    onTabClick(){
      this.form.registerAddress = null;
      this.form.data = '';
      this.form.registerNum = 0;
      // this.registerAddressList = this.getList();
    },
    // 添加数据
    onPlus(){
      this.registerList.push({ registerAddress:null, data:null });
    },
    // 删除数据
    onDel(index){
      this.registerList.splice(index,1);
    },
    // 禁用
    useContentDisabled(value){
      const activeData = registerType.find(item => item.value === value);
      return activeData?.disabled ?? false;
    },
    // 下拉选项
    useOptions(value){
      const activeData = registerType.find(item => item.value === value);
      return activeData?.options ?? [];
    },
    // 内容类型
    useContentType(value){
      const activeData = registerType.find(item => item.value === value);
      return activeData?.contentType ?? 'input';
    },
    // 最大值
    useMin(value){
      const activeData = registerType.find(item => item.value === value);
      return activeData?.min ?? 0;
    },
    // 最小值
    useMax(value){
      const activeData = registerType.find(item => item.value === value);
      return activeData?.max ?? 0;
    },
    initData(){
      this.form = {
        activeType:'0',
        registerAddress:null,
        registerNum:0,
        data:'',
      };
      this.registerList = [];
      this.onPlus();
    },
    // 验证
    onError(){
      if(this.form.activeType === '0'){
        if(!this.form.registerAddress) throw { msg:'请选择寄存器起始地址' };
        if(this.form.registerNum === null && !this.useContentDisabled(this.form.registerAddress)) throw { msg:'请输入寄存器个数' };
      }else if(this.form.activeType === '1'){
        if(!this.form.registerAddress) throw { msg:'请选择寄存器起始地址' };
        if(!this.useContentDisabled(this.form.registerAddress)){
          if(this.form.data === '' || this.form.data === null) throw { msg:'请输入数据' };
        }
      }else if(this.form.activeType === '2'){
        this.registerList.forEach((item,index) => {
          if(!item.registerAddress) throw { msg:`请选择第${index+1}个寄存器起始地址` };
          if(!this.useContentDisabled(item.registerAddress)){
            if(item.data === '' || item.data === null) throw { msg: `请输入第${index+1}数据` };
          }
        });
      }
    },
    // 请求参数
    getParams(){
      if(this.form.activeType === '0'){
        return {
          registerAddress:this.form.registerAddress,
          registerNum:this.form.registerNum,
        }
      }else if(this.form.activeType === '1'){
        return {
          registerAddress:this.form.registerAddress,
          data:this.form.data,
        }
      }else if(this.form.activeType === '2'){
        return {
          list:this.registerList
        }
      }
    },
    // 确认下发
    async commandDown() {
      try {
        this.onError();
        const params = {
          terminalNo:this.params.terminalNo,
          ...this.getParams()
        };
        const url = [
          'instructionIssuanceReadRegister',
          'instructionIssuanceWriteRegister',
          'instructionIssuanceBatchWriteRegister',
        ][Number(this.form.activeType)];
        const { msg, code } = await this.$API[url](params);
        if(code !== 0) throw { msg };
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.$emit("update:visible", false);
      } catch (error) {
        console.log(error)
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin.scss';
::v-deep .el-dialog__body {
  padding: 0;
  .el-input-number{
    line-height: 30px;
  }
  .el-tabs--border-card{
    margin-top: 12px;
    box-shadow: none;
  }
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
::v-deep .el-dialog__footer {
  padding-bottom: 10px;
}
.w__100{
  width: 100%;
}
.register-list{
  max-height: 200px;
  overflow-y:auto;
  @include scrollBar;
  &-item{
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    .el-select{
      margin-right: 10px;
      flex: 1;
    }
    .el-input{
      width: 40%;
    }
    &-operate{
      display: flex;
      margin-left: 10px;
      align-items: center;
      justify-content: flex-start;
      width: 50px;
      >i{
        font-size: 18px;
        cursor: pointer;
      }
      .del{
        margin-right: 10px;
        color: #d30008;
      }
      .plus{
        color: #18C18B;
      }
    }
  }
}
.footer{
  display: flex;
  justify-content: space-between;
}
.Diatitle {
  width: 100%;
  height: 40px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;

  span {
    padding: 0 20px;
    font-size: 18px;
    font-family: 'PingFang SC';
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
/** .read-write{
  ::v-deep .el-form{
    display: flex;
    flex-wrap: wrap;
    max-height: 400px;
    overflow-y: auto;
    @include scrollBar;
    .el-form-item{
      display: flex;
      align-items: center;
      width: 50%;
      margin-bottom: 10px;
      margin-right: 0;
      .el-form-item__label{
        line-height: 20px !important;
      }
    }
  }
}*/
</style>
<style>

</style>
